<template>

  <button type="button" @click="scrollTo(scrollTrigger)" @mouseleave="hoverHandler().leave"
    @mouseover="hoverHandler().over" style="box-shadow: 0 -4px 0 #c7642d inset;"
    class="bg-orangebtn text-white items-center sm-max:px-2 flex lg:leading-[76px] font-bold justify-center gap-x-2 font-ww-medium lg:text-42 md:text-4xl text-xl md:px-3 md:py-3.5 py-4 text-center w-full rounded uppercase btn-cta-custom"
    :class="[devMode && 'split-test-outline', newStyle ? 'md-max:!text-4xl md-max:!py-8 rounded' : '']"
    :data-event-label="dataAttrs['data-event-label']" :data-event-action="dataAttrs['data-event-action']"
    :data-event-name="dataAttrs['data-event-name']">
    {{ renderText }}
    <svg :class="newStyle ? 'md-max:w-6' : ''" width="30" class="md-max:w-4" height="30" viewBox="0 0 30 30" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.06727e-06 17.0991L22.7338 17.0991L14.1237 27.288L17.3229 30L30 15L17.3229 -5.54136e-07L14.1237 2.71201L22.7338 12.9009L3.25078e-06 12.9009L3.06727e-06 17.0991Z"
        fill="white" />
    </svg>

  </button>

</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  dataAttrs: {
    type: Object,
    default: () => ({})
  },
  scrollTrigger: {
    type: String
  },
  newStyle: {
    type: Boolean,
    default: false
  }
})

const renderText = ref(props.text)
const expDetails = props.dataAttrs['data-event-label'] || null
const devMode = useCookie('devMode')

const hoverHandler = () => ({
  leave: () => {
    if (devMode.value && expDetails) {
      renderText.value = props.text
    }

  },
  over: () => {
    if (devMode.value && expDetails) {
      renderText.value = expDetails
    }
  }
})
</script>